import { FUNDRAISER_TABS } from "../constants";

export function validateFundraiserForm(values) {
    const { BASIC_INFO, TELL_A_STORY } = FUNDRAISER_TABS;

    let errors = {}

    switch (values.tab) {
        case BASIC_INFO:
            if (!values.name)
                errors.name = "Page name is required"

            else if (!values.goal || !parseInt(values.goal) > 0)
                errors.goal = "Goal amount is required"
            break;

        case TELL_A_STORY:
            if (!values.name)
                errors.name = "Page name is required"

            else if (!values.goal || !parseInt(values.goal) > 0)
                errors.goal = "Goal amount is required"

            else if (!values.missionStatement.storyWithTags && !values.missionStatement.story)
                errors.missionStatement = "Mission statement is required"
            break;

        default:
            break;
    }

    return errors;
}